import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // Left-aligned so the download links shrink-wrap instead of stretching in flex-column parents.
  list: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  }
});

export default makeStyles(styles);
